import { useEffect, useState, useRef } from 'react';
import Header from '../header';
import {
  Select,
  TextField,
  MenuItem,
  Box,
  Button,
  Card,
  CardContent, IconButton,
  Table,
  TableBody, TableContainer, Tooltip,
  Typography
} from '@mui/material';
import Iconify from 'src/components/iconify';
import {
  emptyRows,
  getComparator,
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  TableSelectedAction,
  useTable,
} from 'src/components/table';
import { useBoolean } from 'src/hooks/use-boolean';
import Scrollbar from 'src/components/scrollbar';
import { isEqual } from 'lodash';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { deleteRequest, getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { useParams } from 'react-router';
import { LoadingScreen } from 'src/components/loading-screen';
import { LoadingButton } from '@mui/lab';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { getCsvData } from './getCsv_subcontractor';
import ImportDilaog from '../../import-modal';
import ProjectList from '../../project-list/project-list-modal';
import UserTableRow from './subcontractor-table-row';
import SettingModal from './settings-modal-AP';
import { CSVLink } from 'react-csv';
import { baseURLnav } from 'src/config-global';

const SubcontractorAmount = () => {
  const { id } = useParams()

  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [actionVisible, setActionVisible] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [projectList, setprojectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState('All');
  const [chartsAccountList, setchartsAccount] = useState([]);
  const [bankInformation, setBankInformation] = useState([]);

  const popover = usePopover();
  const popoverDots = usePopover();

  const csvLinkRef = useRef();

  const getCsvHeaders = () => {
    return TABLE_HEAD.filter(({ id }) => id !== 'action' && id !== 'serial_number').map(({ id, label }) => ({
      label,
      key: id,
    }));
  };

  const handleExport = () => {
    if (csvLinkRef.current) {
      const csvData = getCsvData(tableData);
      csvLinkRef.current.link.click(csvData);
    }
  };

  const TABLE_HEAD = [
    { id: 'serial_number', label: 'Sr.no', key: 'serial_number' },
    { id: 'project_name', label: 'Project Name', key: 'project_name' },
    { id: 'agreement_number', label: 'Agreement Number', key: 'agreement_number' },
    { id: 'subcontractor_name', label: 'Subcontractor Name', key: 'subcontractor_name' },
    { id: 'invoice_date', label: 'Invoice date', key: 'invoice_date' },
    { id: 'payment_terms', label: 'Payment terms', key: 'payment_terms' },
    { id: 'contract_date', label: 'Date', key: 'contract_date' },
    { id: 'item_description', label: 'Description', key: 'item_description' },
    { id: 'item_amount', label: 'Amount', key: 'item_amount' },
    { id: 'amount_paid', label: 'Amount Paid' },
    { id: 'balance', label: 'Balance', key: 'balance' },
    { id: 'notes', label: 'Notes/Remarks', key: 'notes' },
    { id: 'status', label: 'Status', key: 'status' },
    { id: 'action', label: 'Action', key: 'action' },
  ];
  const table = useTable();
  const remove = useBoolean();
  const confirm = useBoolean();
  const create = useBoolean();
  const add = useBoolean();
  const modal = useBoolean();


  const [tableData, setTableData] = useState([]);

  const [filters, setFilters] = useState({
    project_name: "",
    agreement_number: "",
    contractor_name: "",
    contract_terms: "",
    subcon_agreement_items_description: null,
  });

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleCloseFilters = () => {
    popover.onClose();
    setFilters({
      project_name: "",
      agreement_number: "",
      contractor_name: "",
      contract_terms: "",
      subcon_agreement_items_description: "",
    })
  }



  const dataFiltered = applyFilter({
    inputData: tableData?.length > 0 ? tableData : [],
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });

  const dataInPage = dataFiltered.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );
  const denseHeight = table.dense ? 52 : 72;
  const canReset = !isEqual({ name: '', role: [], status: 'all' }, filters);
  const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;


  useEffect(() => {
    getSubContractorList(selectedProject);
    getProjects();
    getChartsOfAccount();
    getBankInformation();
  }, []);


  const getSubContractorList = async (projectId) => {
    setLoading(true);
    const endpoint = projectId && projectId !== 'All'
      ? `${endpoints.accounting.account_payable.subcontractor_amount.get_list}?project_id=${projectId}`
      : endpoints.accounting.account_payable.subcontractor_amount.get_list;

    const data = await getRequest(endpoint);
    if (data) {
      setTableData(data);
    }
    setLoading(false);
  };
  const getChartsOfAccount = async () => {
    const data = await getRequest(endpoints.accounting.expenses.charts_of_account_list);
    if (data) {
      setchartsAccount(data);
    }
  };

  const getBankInformation = async () => {
    const data = await getRequest(endpoints.accounting.bank_information.get_list);
    if (data) {
      setBankInformation(data);
    }
  };
  const getProjects = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_project_list);
    if (data) {
      setprojectList(data);

    }
  };
  const handleChange = (event) => {
    const projectId = event.target.value
    setSelectedProject(projectId);
    getSubContractorList(projectId)
  };
  const deleteCallBack = () => {
    confirm.onFalse();
    getSubContractorList();
  };

  const handleDeleteRows = async (id) => {
    await deleteRequest(
      `${endpoints.risk_management.risk_change_request.crud}/${selectedItem.id}`,
      deleteCallBack
    );
    const updatedTableData = tableData.filter((row) => row.id !== id);
    setTableData(updatedTableData);
    if (updatedTableData.length <= table.page * table.rowsPerPage && table.page > 0) {
      table.onChangePage(null, table.page - 1);
    } else {
      table.onUpdatePageDeleteRow(dataInPage.length);
    }
  };

  const handleBulkDelete = async () => {
    const Ids = table.selected;
    if (Ids.length > 0) {
      try {
        const response = await postRequest(
          endpoints.risk_management.risk_change_request.bulk_delete,
          { ids: Ids }
        );
        remove.onFalse();
        setActionVisible(false); 
        getSubContractorList();
      } catch (error) {
        console.error('Error during bulk delete:', error);
      }
    } else {
      console.warn('No rows selected');
    }
  };

  return (
    <>
      <Card sx={{ height: '100%', marginTop: '10px', overflow: 'hidden' }}>
        {' '}
        <CardContent>
          {loading ? (
            <Box height={700}>
              <LoadingScreen />
            </Box>
          ) : (
            <>
              <Header name="Subcontractor Amount" />
              <div
                style={{
                  backgroundColor: '#F4F6F8',
                  border: '1px solid #FFD700',
                  padding: '10px 10px',
                  borderRadius: '5px',
                  marginTop: '15px',
                  marginBottom: '35px',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    marginLeft: '1px',
                    fontSize: '15px',
                    whiteSpace: 'pre-line',
                  }}
                >
                  <strong>Note:</strong>
                  If you want to create new data,{' '}

                  <a
                    href={`${baseURLnav}/subcontractor-agreements?${id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', fontWeight: 'bold' }}
                  >
                    click here
                  </a>.

                  This will open the project list, where you can select a Project. Once selected, you will be redirected accordingly.
                </Typography>

              </div>

              <Box
                sx={{
                  display: 'flex',
                  paddingBottom: '20px',
                  justifyContent: 'space-between',
                  gap: '12px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    padding: '5px 0',
                  }}
                >
                  <h5
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#333',
                      margin: '0',
                      textTransform: 'none',
                    }}
                  >
                    Project Name
                  </h5>
                  <Select
                    sx={{ minWidth: 65, height: 35 }}
                    value={selectedProject}
                    onChange={handleChange}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {projectList?.map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    paddingBottom: '20px',
                    justifyContent: 'flex-end',
                    gap: '12px',
                  }}
                >
                  <Button
                    onClick={popover.onOpen}
                    className="dark-button"
                    variant="contained"
                    sx={{ mx: 1 }}
                    startIcon={<Iconify icon="mdi:filter" />}
                  >
                    Filter
                  </Button>
                  {/* <Button
                    onClick={modal.onTrue}
                    className="dark-button"
                    variant="contained"
                    startIcon={<Iconify icon="mingcute:add-line" />}
                  >
                    Settings
                  </Button> */}
                  <IconButton onClick={popoverDots.onOpen}>
                    <Iconify icon="eva:more-vertical-fill" />
                  </IconButton>
                </Box>
              </Box>

              <CustomPopover
                open={popoverDots.open}
                onClose={popoverDots.onClose}
                arrow="right-top"
                sx={{ width: 140 }}
              >
                <MenuItem
                  onClick={() => {
                    handleExport();
                    popoverDots.onClose();
                  }}
                >
                  <Iconify icon="solar:export-bold" />
                  Export
                </MenuItem>
              </CustomPopover>

              <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                arrow="bottom-bottom"
                sx={{
                  width: 1000,
                  padding: 2,
                  background: 'white !important',
                  left: '310px !important',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <MenuItem
                  disableRipple
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    color: '#000',
                    background: 'white !important',
                    '&:hover': { backgroundColor: 'white !important' },
                  }}
                >
                  <Iconify
                    icon="mdi:close"
                    onClick={handleCloseFilters}
                    sx={{
                      width: 20,
                      height: 20,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      backgroundColor: '#F4F6F8',
                      color: '#637381',
                    }}
                  />

                  <TextField
                    label="Project Name"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.project_name}
                    onChange={(e) => handleFilterChange('project_name', e.target.value)}
                    sx={{
                      flex: 1,
                      background: 'white !important',
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />

                  <TextField
                    label="Agreement Number"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.agreement_number}
                    onChange={(e) => handleFilterChange('agreement_number', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />
                  <TextField
                    label="Contractor Name"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.contractor_name}
                    onChange={(e) => handleFilterChange('contractor_name', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />

                  <TextField
                    label="Contract Terms"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.contract_terms}
                    onChange={(e) => handleFilterChange('contract_terms', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />
                  <TextField
                    label="Description"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.subcon_agreement_items_description}
                    onChange={(e) => handleFilterChange('subcon_agreement_items_description', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />
                </MenuItem>
              </CustomPopover>

              <Card
                sx={{
                  boxShadow: '0px 0px 30px 0px #64748B1A',
                }}
              >
                <TableContainer sx={{ position: 'relative', overflow: 'auto' }}>
                  {actionVisible && (
                    <div style={{ marginBottom: table.selected.length > 0 ? '3rem' : '0' }}>
                      <TableSelectedAction
                        dense={table.dense}
                        numSelected={table.selected.length}
                        rowCount={tableData?.length}
                        onSelectAllRows={(checked) =>
                          table.onSelectAllRows(
                            setActionVisible(checked),
                            checked,
                            tableData.map((row) => row.id)
                          )
                        }
                        action={
                          <Tooltip title="Delete">
                            <IconButton color="primary" onClick={remove.onTrue}>
                              <Iconify icon="solar:trash-bin-trash-bold" />
                            </IconButton>
                          </Tooltip>
                        }
                      />
                    </div>
                  )}
                  <Scrollbar>
                    <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                      <Scrollbar>
                        <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
                          <TableHeadCustom
                            order={table.order}
                            orderBy={table.orderBy}
                            headLabel={TABLE_HEAD}
                            rowCount={tableData.length}
                            numSelected={table.selected.length}
                            onSort={table.onSort}
                            onSelectAllRows={(checked) =>
                              table.onSelectAllRows(
                                checked,
                                tableData.map((row) => row.id)
                              )
                            }
                          />
                          <TableBody>
                            {dataFiltered
                              .slice(
                                table.page * table.rowsPerPage,
                                table.page * table.rowsPerPage + table.rowsPerPage
                              )
                              .map((row, index) => (
                                <UserTableRow
                                  key={row.id}
                                  row={row}
                                  selected={table.selected.includes(row.id)}
                                  onSelectRow={() => table.onSelectRow(row.id)}
                                  bankInformation={bankInformation}
                                  reload={() => getSubContractorList()}
                                  reloadBankInfo={()=> getBankInformation()}
                                  chartsAccountList={chartsAccountList}
                                  serialNumber={table.page * table.rowsPerPage + index + 1}
                                />
                              ))}
                            <TableEmptyRows
                              height={denseHeight}
                              emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                            />

                            <TableNoData notFound={notFound} />
                          </TableBody>
                        </Table>
                      </Scrollbar>
                    </TableContainer>
                  </Scrollbar>
                </TableContainer>

                <TablePaginationCustom
                  count={dataFiltered.length}
                  page={table.page}
                  rowsPerPage={table.rowsPerPage}
                  onPageChange={table.onChangePage}
                  onRowsPerPageChange={table.onChangeRowsPerPage}
                  dense={table.dense}
                  onChangeDense={table.onChangeDense}
                />
              </Card>
            </>
          )}
          {
            <CSVLink
              ref={csvLinkRef}
              filename="SubContractor Amount.csv"
              headers={getCsvHeaders()}
              data={getCsvData(tableData)}
              style={{ display: 'none' }}
            />
          }
        </CardContent>
      </Card>

      <SettingModal
        open={modal.value}
        onClose={modal.onFalse}
      />

      <ImportDilaog
        open={create.value}
        onClose={create.onFalse}
        reload={() => { }}
      />

      <ProjectList
        open={add.value}
        onClose={add.onFalse}
      />
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you want to delete selected items?"
        action={
          <Button
            variant="contained"
            className="dark-button"
            onClick={() => {
              handleDeleteRows();
              confirm.onFalse();
            }}
          >
            Delete
          </Button>
        }
      />

      <ConfirmDialog
        open={remove.value}
        onClose={remove.onFalse}
        title="Delete"
        content={<>Are you sure want to delete these items?</>}
        action={
          <LoadingButton
            loading={deleteLoading}
            variant="contained"
            className="dark-button"
            onClick={() => {
              handleBulkDelete();
            }}
          >
            Delete
          </LoadingButton>
        }
      />
    </>
  );
};

export default SubcontractorAmount;

function applyFilter({ inputData, comparator, filters }) {
  const {
    project_name,
    agreement_number,
    contractor_name,
    contract_terms,
    subcon_agreement_items_description,
  } = filters;

  const stabilizedThis = inputData.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  inputData = stabilizedThis.map((el) => el[0]);

  if (project_name) {
    inputData = inputData.filter((row) =>
      row.project?.name.toString().toLowerCase().includes(project_name.toString().toLowerCase())
    );
  }
  if (agreement_number) {
    inputData = inputData.filter((row) =>
      row.agreement_number.toString().toLowerCase().includes(agreement_number.toString().toLowerCase())
    );
  }
  if (contractor_name) {
    inputData = inputData.filter((row) =>
      (row.contractor?.first_name + " " + row.contractor?.last_name)
        .toString()
        .toLowerCase()
        .includes(contractor_name.toString().toLowerCase())
    );
  }
  if (contract_terms) {
    inputData = inputData.filter((row) =>
      row.contract_terms.toString().toLowerCase().includes(contract_terms.toString().toLowerCase())
    );
  }
  if (subcon_agreement_items_description) {
    inputData = inputData.filter((row) =>
      row.subcon_agreement_items[0]?.description
        ? row.subcon_agreement_items[0].description
          .toString()
          .toLowerCase()
          .includes(subcon_agreement_items_description.toString().toLowerCase())
        : false
    )
  }

  return inputData;
}
